import { render } from "./pagefive.vue?vue&type=template&id=37107464&scoped=true"
import script from "./pagefive.vue?vue&type=script&lang=js"
export * from "./pagefive.vue?vue&type=script&lang=js"

import "./pagefive.vue?vue&type=style&index=0&id=37107464&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37107464"]])

export default __exports__